export default "__VITE_ASSET__HYraE9Kh__"